import $ from 'jquery';
import 'jquery.scrollbar';

export default class Feedback {
	constructor() {
		this.usefulInformation = $('.useful-information');
		this.title = $('.useful-information__title');
		this.feedback = $('.feedback');
		this.close = $('.feedback__close');
		this.textareaWrapper = $('.feedback__textarea-wrapper');
		this.textarea = $('.feedback__textarea');
		this.submit = $('.feedback__submit');
	}

	init() {
		this.textarea.scrollbar();

		this.close.on('click', event => {
			event.preventDefault();

			this.feedback.removeClass('feedback_open');
		});

		$(document.body).on('click', event => {
			if (!$(event.target).closest('.feedback__form, .button-confirm_no').length) {
				this.feedback.removeClass('feedback_open');
			}
		});

		this.submit.on('click', event => {
			event.preventDefault();

			this.feedback.removeClass('feedback_open');
			this.usefulInformation.addClass('useful-information_success');
			this.title.html('Спасибо за ваш ответ!');
		});

		this.textarea.on('focus', () => {
			this.textareaWrapper.addClass('feedback__textarea-wrapper_focus');
		});

		this.textarea.on('blur', () => {
			this.textareaWrapper.removeClass('feedback__textarea-wrapper_focus');
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/feedback/index.js